import React from 'react';

import BouncedEmailListItem from './BouncedEmailListItem';

import { IGroupMember } from '../../../store/group/groupState';

interface IOwnProps {
    members: IGroupMember[];
    deleteFromList: (diNumber: number) => void;
}

class BouncedEmailList extends React.Component<IOwnProps> {
    public render() {
        if (!this.props.members.length)
        {
            return <></>;
        }

        return <React.Fragment>
            <table className="table has-actions table--responsive">
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>Email</th>
                        <th>Dato</th>
                        <th>Fejlende leverancer</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.members.map((member, index) => {
                        return (<BouncedEmailListItem member={member} deleteFromList={this.props.deleteFromList} key={index} />)
                    })}
                </tbody>
            </table>
        </React.Fragment>;
    }
}

export default BouncedEmailList;

